import { render, staticRenderFns } from "./importTable.vue?vue&type=template&id=24e03d7a"
import script from "./importTable.vue?vue&type=script&lang=js"
export * from "./importTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports